export enum CheckType {
  Checkbox = 'checkbox',
  Radio = 'radio'
}

export enum Placement {
  Left = 'left',
  Right = 'right'
}
